var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFiltersSwitch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Filters_Icon",
    "data-name": "Filters Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3938",
    "data-name": "Group 3938"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1197",
    "data-name": "Rectangle 1197",
    width: 18,
    height: 18,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    d: "M16.675,4H9.137A2.325,2.325,0,0,0,7,2.5,2.25,2.25,0,0,0,4.9,4H3.325a.787.787,0,0,0-.825.75.788.788,0,0,0,.825.75H4.9A2.25,2.25,0,0,0,7,7,2.325,2.325,0,0,0,9.137,5.5h7.538a.788.788,0,0,0,.825-.75A.787.787,0,0,0,16.675,4ZM7,5.5a.75.75,0,1,1,.75-.75A.75.75,0,0,1,7,5.5Z",
    transform: "translate(-2.5 -2.5)",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    d: "M16.725,12.75H15.188a2.325,2.325,0,0,0-2.138-1.5,2.25,2.25,0,0,0-2.1,1.5H3.375a.75.75,0,1,0,0,1.5H10.95a2.25,2.25,0,0,0,2.1,1.5,2.325,2.325,0,0,0,2.137-1.5h1.538a.75.75,0,0,0,0-1.5Zm-3.675,1.5a.75.75,0,1,1,.75-.75A.75.75,0,0,1,13.05,14.25Z",
    transform: "translate(-2.55 -6)",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    d: "M16.725,21.5H10.313A2.325,2.325,0,0,0,8.175,20a2.25,2.25,0,0,0-2.1,1.5h-2.7a.75.75,0,0,0,0,1.5h2.7a2.25,2.25,0,0,0,2.1,1.5A2.325,2.325,0,0,0,10.313,23h6.413a.75.75,0,0,0,0-1.5ZM8.175,23a.75.75,0,1,1,.75-.75A.75.75,0,0,1,8.175,23Z",
    transform: "translate(-2.55 -9.5)",
    fill: "#737373"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFiltersSwitch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filters-switch.21d6f058e25fb9dbbe509796abb632e7.svg";